import React from 'react';

const DollarFormatter = ({ value }) => {
  if (typeof value !== 'number') return <span>—</span>; // or "N/A", or "$0.00" depending on your preference

  const formattedValue = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(value);

  return <span>{formattedValue}</span>;
};

export default DollarFormatter;
